import { Box, TextField, Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";

import ShipperAPI from "../api/Shipper.api";
import BasicShowEdit from "../components/BasicShowEdit";
import Layout from "../components/Layout";
import { Shipper, ShipperInput } from "../types";

export default function ShipperShow() {
  const { id } = useParams();
  const { data: shipper } = ShipperAPI.useDetail(id);

  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Shippers</Typography>
        </Box>

        {shipper && <ShipperForm shipper={shipper} />}
      </Box>
    </Layout>
  );
}

function ShipperForm({ shipper }: { shipper: Shipper }) {
  const [name, setName] = React.useState<string>(shipper.name);

  const input: ShipperInput = {
    ...shipper,
    name,
  };

  return (
    <BasicShowEdit
      modelApiUseSave={ShipperAPI.useSave}
      modelApiUseDelete={ShipperAPI.useDelete}
      modelInput={input}
    >
      <TextField
        label="Name"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
    </BasicShowEdit>
  );
}
